export const CLASS_OPEN = 'is-bundle-builder-open';

const template = document.createElement('template');
template.innerHTML = `
  <style>
    h2 {
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 485;
      line-height: 2.5rem;
      letter-spacing: 0.045rem;
      text-transform: uppercase;
      margin-bottom: 63px;
    }

    @media screen and (max-width: 991px) {
      h2 {
        margin-bottom: 24px;
      }
    }
  </style>
  <div class="bundle-title" part="title">
    <h2 title>Your Pack - $<span amount></span></h2>
  </div>
`;

export class BundleTitle extends HTMLElement {

  private readonly root:HTMLDivElement|null;
  private amountElement:HTMLElement;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));


    this.root = shadowRoot.querySelector('.bundle-title')!;

    this.amountElement = shadowRoot.querySelector('[amount]')!;

    this.updateTitle(0);
  }

  public updateTitle(amount) {
    this.amountElement.textContent = amount;
  }

}

if(!customElements.get('bundle-title')) {
  customElements.define('bundle-title', BundleTitle);
}